import { render, staticRenderFns } from "./XmSuccessDialog.vue?vue&type=template&id=037843fe&scoped=true"
import script from "./XmSuccessDialog.vue?vue&type=script&lang=js"
export * from "./XmSuccessDialog.vue?vue&type=script&lang=js"
import style0 from "./XmSuccessDialog.vue?vue&type=style&index=0&id=037843fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037843fe",
  null
  
)

export default component.exports